import globalSlice from "./slices/globalSlice";
import userSlice from "./slices/userSlice";
import roleSlice from "./slices/roleSlice";
import permissionSlice from "./slices/permissionSlice";
import vendorSlice from "./slices/vendorSlice";
import { combineReducers } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
  global: globalSlice,
  user: userSlice,
  role: roleSlice,
  permission: permissionSlice,
  vendor: vendorSlice,
  
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
